import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const ResourceTab = () => {
  // Keep resources JSON inside component
  const resources = [
    {
      name: "Conference Room Booking",
      description: "Reserve and manage meeting or conference rooms within the office.",
      url: "https://outlook.office.com/book/ConferenceRoom2@divergentinsights.com/s/mb1TSRjZyk2tG3NT7ZMZsw2?ismsaljsauthenabled",
    },
    {
      name: "HROne",
      description: "Access HRone cloud platform for comprehensive HR management and services.",
      url: "https://app.hrone.cloud",
    },
    // {
    //   name: "GMOS Help Center",
    //   description: "Support and FAQs for Marketplace for Online Sampling",
    //   url: "https://gmos.example.com/help",
    // },
    // {
    //   name: "Expense Management",
    //   description: "Submit and track non-project expenses",
    //   url: "https://expenses.example.com",
    // },
  ];

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
        Resources & Useful Links
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Access helpful resources, documentation, and support links below.
      </Typography>

      <Grid container spacing={3}>
        {resources.map((resource, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 4,
                },
              }}
            >
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                  {resource.name}
                </Typography>
                {resource.description && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    {resource.description}
                  </Typography>
                )}
              </CardContent>
              <CardActions>
                <Button
                  size="small"
                  variant="outlined"
                  endIcon={<OpenInNewIcon />}
                  onClick={() => window.open(resource.url, "_blank")}
                >
                  Open
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ResourceTab;
